import { useCurrentOrderMutation } from "~/api/orders/hooks/use-create-order";

import { type KioskPaymentMethod } from "./get-kiosk-payment-buttons";

type KioskCheckoutStatus = {
  /** `idle` when no matching order has been started yet. */
  status: "idle" | "pending" | "error" | "success";
  error: Error | null;
  /** The method the in-flight order was started with, for branching UI. */
  paymentMethod: KioskPaymentMethod | null;
};

/**
 * Reads the status of the current kiosk order (the query half of checkout).
 *
 * Backed by the shared mutation cache (`useCurrentOrderMutation`), so it
 * reports the same state regardless of which screen started the payment.
 * Covers the standard card/swish/credit flow; the FreedomPay flow has its own
 * richer status in `useFreedomPayOrderStatus`.
 */
export const useKioskCheckoutStatus = (): KioskCheckoutStatus => {
  const mutation = useCurrentOrderMutation();

  return {
    status: mutation?.status ?? "idle",
    error: mutation?.error ?? null,
    paymentMethod: mutation?.variables?.paymentMethod ?? null
  };
};
